/**
 * Test IDs for QA automation.
 */
export const testIds = {
  documentsUploadModalAddDocument: "documents-upload-modal-add-document",
  documentsUploadModalCancel: "documents-upload-modal-cancel",
  documentsUploadModalUploadDocuments: "documents-upload-modal-upload-documents",
} as const;
